/** Session-Status-Hilfen (Shared: Web CoachDesk, Mobile, Admin). */

export const SESSION_STATUS = Object.freeze({
  PLANNED: "planned",
  COMPLETED: "completed",
  CANCELLED_WEATHER: "cancelled_weather",
  CANCELLED_TRAINER: "cancelled_trainer",
  CANCELLED_COURT: "cancelled_court",
  CANCELLED_PARTICIPANTS: "cancelled_participants",
  CANCELLED_CLUB: "cancelled_club",
  CANCELLED_HOLIDAY: "cancelled_holiday",
  POSTPONED: "postponed",
  CANCELLED_OTHER: "cancelled_other",
});

const CANCELLED_STATUSES = new Set([
  SESSION_STATUS.CANCELLED_WEATHER,
  SESSION_STATUS.CANCELLED_TRAINER,
  SESSION_STATUS.CANCELLED_COURT,
  SESSION_STATUS.CANCELLED_PARTICIPANTS,
  SESSION_STATUS.CANCELLED_CLUB,
  SESSION_STATUS.CANCELLED_HOLIDAY,
  SESSION_STATUS.POSTPONED,
  SESSION_STATUS.CANCELLED_OTHER,
]);

export function isCancelledSessionStatus(status) {
  const st = String(status || "").trim();
  if (!st || st === SESSION_STATUS.PLANNED || st === SESSION_STATUS.COMPLETED) return false;
  if (st === SESSION_STATUS.POSTPONED) return true;
  if (st.startsWith("cancelled_")) return true;
  return CANCELLED_STATUSES.has(st);
}

export function getSessionEffectiveStatus(session) {
  const raw = String(session?.status || "").trim();
  if (raw) return raw;
  return session?.attendance_confirmed ? SESSION_STATUS.COMPLETED : SESSION_STATUS.PLANNED;
}

export function isCancelledSession(session) {
  return isCancelledSessionStatus(getSessionEffectiveStatus(session));
}

export function isSessionCompleted(session) {
  return getSessionEffectiveStatus(session) === SESSION_STATUS.COMPLETED;
}

export function isSoftDeletedSession(session) {
  const v = session?.deleted_at;
  return v != null && String(v).trim() !== "";
}
